import { render, staticRenderFns } from "./CallbackRequests.vue?vue&type=template&id=9741f142&"
import script from "./CallbackRequests.vue?vue&type=script&lang=js&"
export * from "./CallbackRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports